import { render, staticRenderFns } from "./ContentCard.vue?vue&type=template&id=28a286dc&scoped=true"
import script from "./ContentCard.vue?vue&type=script&lang=js"
export * from "./ContentCard.vue?vue&type=script&lang=js"
import style0 from "./ContentCard.vue?vue&type=style&index=0&id=28a286dc&prod&scoped=true&lang=scss"
import style1 from "./ContentCard.vue?vue&type=style&index=1&id=28a286dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a286dc",
  null
  
)

export default component.exports